export const V2_PREFIX = "/v2";

export const isV2Path = (pathname = window.location.pathname) => {
  const normalizedPath = String(pathname || "").toLowerCase();

  return (
    normalizedPath === V2_PREFIX ||
    normalizedPath.startsWith(`${V2_PREFIX}/`)
  );
};

export const stripVersionPrefix = (pathname = "") => {
  const normalizedPath = String(pathname || "");
  const lowerPath = normalizedPath.toLowerCase();

  return lowerPath === V2_PREFIX
    ? "/"
    : lowerPath.startsWith(`${V2_PREFIX}/`)
    ? normalizedPath.slice(V2_PREFIX.length)
    : normalizedPath;
};

export const hasValidTrackingReference = (referenceId) => {
  const normalizedReference = String(referenceId ?? "")
    .trim()
    .toLowerCase();

  return (
    Boolean(normalizedReference) &&
    normalizedReference !== "null" &&
    normalizedReference !== "undefined"
  );
};

const getNormalizedRequestTarget = (target) => {
  const targetPath = `/${String(target || "").replace(/^\/+/, "")}`;

  return stripVersionPrefix(targetPath)
    .replace(/^\/+/, "")
    .replace(/\/+$/, "")
    .toLowerCase();
};

export const getPostLoginPath = (
  params,
  pathname = window.location.pathname,
) => {
  const nextTarget = getNormalizedRequestTarget(params?.get?.("nextTarget"));
  const hasReference = hasValidTrackingReference(params?.get?.("rid"));
  const hasTrackingIdentifier =
    hasReference ||
    (isV2Path(pathname) &&
      hasValidTrackingReference(params?.get?.("request_id")));

  if (nextTarget === "tracking" && hasTrackingIdentifier) {
    return "/tracking";
  }

  if (
    nextTarget === "pickup-image-submission" &&
    hasReference &&
    hasValidTrackingReference(params?.get?.("awb"))
  ) {
    return isV2Path(pathname) ? "/tracking" : "/pickup-image-submission";
  }

  return "/orders";
};

export const shouldForwardRequestTarget = (target, referenceId) => {
  const normalizedTarget = getNormalizedRequestTarget(target);

  return (
    ["tracking", "pickup-image-submission"].includes(normalizedTarget) &&
    hasValidTrackingReference(referenceId)
  );
};

export const versionedPath = (path, pathname = window.location.pathname) => {
  if (!path || !path.startsWith("/") || path.startsWith(`${V2_PREFIX}/`)) {
    return path;
  }

  if (path === "/") {
    return isV2Path(pathname) ? V2_PREFIX : path;
  }

  return isV2Path(pathname) ? `${V2_PREFIX}${path}` : path;
};

export const withQuery = (path, encipherencode) => {
  let url = versionedPath(path);

  if (encipherencode) {
    url += `?encipherencode=${encipherencode}`;
  }

  return url;
};
